import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import Vorstand from "@/components/Vorstand";
import Wasser from "@/components/Wasser";
import News from "@/components/News";
import WeatherWarnings from "@/components/WeatherWarnings";
import Termine from "@/components/Termine";
import RainRadar from "@/components/RainRadar";
import Galerie from "@/components/Galerie";
import Rufnummern from "@/components/Rufnummern";
import Links from "@/components/Links";
import Membership from "@/components/Membership";
import Kontakt from "@/components/Kontakt";
import Footer from "@/components/Footer";
import Admin from "@/pages/Admin";
import Forum from "@/pages/Forum";
import ResetPassword from "@/pages/ResetPassword";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";

function HomePage() {
  useEffect(() => {
    if (!sessionStorage.getItem("kga_visited")) {
      sessionStorage.setItem("kga_visited", "1");
      fetch(`${process.env.REACT_APP_BACKEND_URL}/api/track`, { method: "POST" }).catch(() => {});
    }
    const lenis = new Lenis({
      duration: 1.15,
      anchors: true,
      smoothWheel: true,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#F8F7F2] text-[#1A251E]" data-testid="app-root">
      <Nav />
      <WeatherWarnings />
      <main>
        <Hero />
        <Marquee />
        <News />
        <Termine />
        <RainRadar />
        <About />
        <Vorstand />
        <Wasser />
        <Galerie />
        <Rufnummern />
        <Links />
        <Membership />
        <Kontakt />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/forum" element={<Forum />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/datenschutz" element={<Datenschutz />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
